import AiDocumentTableItem from './AiDocumentTableItem'

export default AiDocumentTableItem
